import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useTheme,
  useMediaQuery,
  Alert,
  CircularProgress,
  Stack,
 
  Avatar,
  Badge,
  Tooltip,
  Snackbar,
} from '@mui/material';
import {
  Search,
  FilterList,
  Refresh,
  Visibility,
  Person,
  Email,
  Phone,
 
  Loyalty,
  Block,
 
  Download,
} from '@mui/icons-material';
import axios from 'axios';
import Sidebar from '../../../../components/sidebars/sidebar_reception';
import TopNav from '../../../../components/TopNav_hotelStaff';

// API base URL - make sure this is properly set in your environment
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const HotelGuestsManagement = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  
  // State management
  const [loading, setLoading] = useState(false);
  const [guests, setGuests] = useState([]);
  const [filteredGuests, setFilteredGuests] = useState([]);
  const [selectedGuest, setSelectedGuest] = useState(null);
  const [error, setError] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  
  // Filter states
  const [filters, setFilters] = useState({
    search: '',
    nationality: '',
    gender: '',
    loyaltyTier: '',
    isBlacklisted: '',
  });
  
  // Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  // Dialog states
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [guestHistory, setGuestHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);

  // Navigation and sidebar
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // Snackbar function
  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userProfile');
    navigate('/Entri');
  };

  const handleNotificationClick = () => {
    alert('You have new notifications!');
  };

  // Get hotel code from user context - FIXED
  const getHotelCode = () => {
    try {
      const storedProfile = JSON.parse(localStorage.getItem('userProfile')) || {};
      console.log('Full user profile:', storedProfile);
      
      // Try different possible field names
      const hotelCode = storedProfile.hotelcode || 
                       storedProfile.hotel_code || 
                       storedProfile.hotelCode || 
                       'eHT5678042024'; // fallback to your test hotel code
      
      console.log('Using hotel code:', hotelCode);
      
      if (!hotelCode) {
        console.error('No hotel code found! Available keys:', Object.keys(storedProfile));
        return 'eHT5678042024';
      }
      
      return hotelCode;
    } catch (error) {
      console.error('Error getting hotel code:', error);
      return 'eHT5678042024'; // fallback
    }
  };

  // API service functions - FIXED
  const api = {
    // Get all guests with filters
   // Get all guests with filters
// Get all guests with filters
getGuests: async (params = {}) => {
  try {
    console.log('Making API call to:', `${API_BASE_URL}/hotel/rooms/guest.php`);
    console.log('Params:', { hotel_code: getHotelCode(), ...params });
    
    const response = await axios.get(`${API_BASE_URL}/hotel/rooms/guest.php`, {
      params: { 
        hotel_code: getHotelCode(), 
        ...params 
      },
      timeout: 10000,
      transformResponse: [function (data) {
        // Clean the response data before JSON parsing
        try {
          // Remove any extra whitespace or invisible characters
          const cleanedData = data.trim();
          return JSON.parse(cleanedData);
        } catch (e) {
          console.error('JSON parse error:', e);
          console.error('Raw response data:', data);
          // Return a fallback structure if parsing fails
          return { success: false, error: 'Invalid JSON response', guests: [] };
        }
      }]
    });
    
    console.log('Processed API Response:', response.data);
    
    // Check if response has the expected structure
    if (response.data && typeof response.data === 'object') {
      return response.data;
    } else {
      console.error('Unexpected response structure:', response.data);
      return { 
        success: false, 
        error: 'Unexpected response format', 
        guests: [] 
      };
    }
  } catch (error) {
    console.error('Error fetching guests:', error);
    const errorMessage = error.response?.data?.error || error.message || 'Failed to fetch guests';
    return { 
      success: false, 
      error: errorMessage, 
      guests: [] 
    };
  }
},
    // Get guest booking history
    getGuestHistory: async (guestId) => {
      try {
        console.log('Fetching history for guest:', guestId);
        const response = await axios.get(`${API_BASE_URL}/hotel/rooms/guest-history.php`, {
          params: { 
            hotel_code: getHotelCode(),
            guest_id: guestId
          },
          timeout: 10000
        });
        console.log('Guest history response:', response.data);
        return response.data;
      } catch (error) {
        console.error('Error fetching guest history:', error);
        console.error('Error details:', error.response?.data || error.message);
        return { 
          success: false, 
          error: error.response?.data?.error || error.message || 'Failed to fetch guest history', 
          bookings: [] 
        };
      }
    },

    // Update guest status
    updateGuestStatus: async (guestId, isBlacklisted, reason = '') => {
      try {
        console.log('Updating guest status:', { guestId, isBlacklisted, reason });
        const response = await axios.put(`${API_BASE_URL}/hotel/rooms/guest-status.php`, {
          guest_id: guestId,
          hotel_code: getHotelCode(),
          is_blacklisted: isBlacklisted,
          blacklist_reason: reason
        }, {
          headers: {
            'Content-Type': 'application/json',
          },
          timeout: 10000
        });
        console.log('Update status response:', response.data);
        return response.data;
      } catch (error) {
        console.error('Error updating guest status:', error);
        console.error('Error details:', error.response?.data || error.message);
        return { 
          success: false, 
          error: error.response?.data?.error || error.message || 'Failed to update guest status' 
        };
      }
    }
  };

  // Load initial data
  useEffect(() => {
    loadGuests();
  }, []);

  // Apply filters when they change
  useEffect(() => {
    applyFilters();
  }, [filters, guests]);

  const loadGuests = async () => {
  setLoading(true);
  setError('');
  try {
    console.log('Starting to load guests...');
    const guestsData = await api.getGuests();
    
    console.log('Received guests data:', guestsData);
    
    // More flexible success checking
    if (guestsData && (guestsData.success === true || guestsData.guests)) {
      const guestsArray = guestsData.guests || [];
      setGuests(guestsArray);
      console.log(`Successfully set ${guestsArray.length} guests to state`);
      
      if (guestsArray.length === 0) {
        showSnackbar('No guests found for this hotel', 'info');
      } else {
        showSnackbar(`Loaded ${guestsArray.length} guests successfully`, 'success');
      }
    } else {
      const errorMsg = guestsData?.error || 'Failed to load guests data';
      setError(errorMsg);
      console.error('Error in response:', errorMsg);
      setGuests([]);
      showSnackbar(errorMsg, 'error');
    }
  } catch (error) {
    const errorMsg = `Network error: ${error.message}`;
    setError(errorMsg);
    console.error('Exception loading guests:', error);
    setGuests([]);
    showSnackbar('Network error loading guests', 'error');
  } finally {
    setLoading(false);
  }
};
  const applyFilters = () => {
    let filtered = [...guests];

    // Search filter
    if (filters.search) {
      const searchTerm = filters.search.toLowerCase();
      filtered = filtered.filter(guest => 
        (guest.first_name?.toLowerCase() || '').includes(searchTerm) ||
        (guest.last_name?.toLowerCase() || '').includes(searchTerm) ||
        (guest.email?.toLowerCase() || '').includes(searchTerm) ||
        (guest.phone?.toString() || '').includes(searchTerm) ||
        (guest.nationality?.toLowerCase() || '').includes(searchTerm)
      );
    }

    // Nationality filter
    if (filters.nationality) {
      filtered = filtered.filter(guest => 
        guest.nationality === filters.nationality
      );
    }

    // Gender filter
    if (filters.gender) {
      filtered = filtered.filter(guest => 
        guest.gender === filters.gender
      );
    }

    // Loyalty tier filter
    if (filters.loyaltyTier) {
      filtered = filtered.filter(guest => {
        const points = parseInt(guest.loyalty_points) || 0;
        switch (filters.loyaltyTier) {
          case 'bronze': return points < 100;
          case 'silver': return points >= 100 && points < 500;
          case 'gold': return points >= 500 && points < 1000;
          case 'platinum': return points >= 1000;
          default: return true;
        }
      });
    }

    // Blacklist filter
    if (filters.isBlacklisted !== '') {
      filtered = filtered.filter(guest => 
        guest.is_blacklisted === (filters.isBlacklisted === 'true')
      );
    }

    setFilteredGuests(filtered);
    setPage(0);
  };

  const handleFilterChange = (field) => (event) => {
    setFilters(prev => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  const clearFilters = () => {
    setFilters({
      search: '',
      nationality: '',
      gender: '',
      loyaltyTier: '',
      isBlacklisted: '',
    });
    showSnackbar('Filters cleared', 'info');
  };

  const handleViewDetails = async (guest) => {
    setSelectedGuest(guest);
    setDetailsDialogOpen(true);
    setHistoryLoading(true);
    
    // Load guest booking history
    try {
      const historyData = await api.getGuestHistory(guest.id);
      if (historyData.success) {
        setGuestHistory(historyData.bookings || []);
        console.log('Guest history loaded:', historyData.bookings);
      } else {
        console.error('Failed to load guest history:', historyData.error);
        setGuestHistory([]);
      }
    } catch (error) {
      console.error('Error loading guest history:', error);
      setGuestHistory([]);
    } finally {
      setHistoryLoading(false);
    }
  };

  const handleToggleBlacklist = async (guest, blacklist = true) => {
    const reason = blacklist ? prompt('Please enter reason for blacklisting:') : '';
    if (blacklist && reason === null) return; // User cancelled
    if (blacklist && !reason?.trim()) {
      showSnackbar('Please enter a reason for blacklisting.', 'warning');
      return;
    }

    try {
      const result = await api.updateGuestStatus(guest.id, blacklist, reason || '');
      if (result.success) {
        // Update local state
        const updatedGuests = guests.map(g => 
          g.id === guest.id ? { ...g, is_blacklisted: blacklist, blacklist_reason: reason || '' } : g
        );
        setGuests(updatedGuests);
        
        // Update selected guest if open
        if (selectedGuest && selectedGuest.id === guest.id) {
          setSelectedGuest(prev => ({ ...prev, is_blacklisted: blacklist, blacklist_reason: reason || '' }));
        }
        
        showSnackbar(`Guest ${blacklist ? 'blacklisted' : 'removed from blacklist'} successfully!`, 'success');
      } else {
        showSnackbar(result.error || 'Failed to update guest status', 'error');
      }
    } catch (error) {
      console.error('Error updating guest status:', error);
      showSnackbar('Failed to update guest status', 'error');
    }
  };

  // Calculate guest statistics
  const calculateStats = () => {
    const totalGuests = filteredGuests.length;
    const blacklistedGuests = filteredGuests.filter(g => g.is_blacklisted).length;
    const loyalGuests = filteredGuests.filter(g => (parseInt(g.loyalty_points) || 0) >= 500).length;
    
    // Calculate new guests (those with 1 or fewer stays)
    const newGuests = filteredGuests.filter(g => {
      const stays = parseInt(g.total_stays) || 0;
      return stays <= 1;
    }).length;

    return {
      totalGuests,
      blacklistedGuests,
      loyalGuests,
      newGuests
    };
  };

  const stats = calculateStats();

  // Get unique nationalities for filter
  const nationalities = [...new Set(guests.map(guest => guest.nationality).filter(Boolean))].sort();

  // Get loyalty tier color
  const getLoyaltyColor = (points) => {
    const pointsNum = parseInt(points) || 0;
    if (pointsNum >= 1000) return 'secondary'; // Platinum
    if (pointsNum >= 500) return 'warning'; // Gold
    if (pointsNum >= 100) return 'default'; // Silver
    return 'primary'; // Bronze
  };

  // Get loyalty tier name
  const getLoyaltyTier = (points) => {
    const pointsNum = parseInt(points) || 0;
    if (pointsNum >= 1000) return 'Platinum';
    if (pointsNum >= 500) return 'Gold';
    if (pointsNum >= 100) return 'Silver';
    return 'Bronze';
  };

  // Generate avatar color based on name
  const stringToColor = (string) => {
    if (!string) return '#1976d2';
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (error) {
      return 'Invalid Date';
    }
  };

  // Format currency
  const formatCurrency = (amount) => {
    if (!amount) return '₦0';
    return `₦${parseFloat(amount).toLocaleString('en-NG')}`;
  };

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main Content */}
      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          ml: isMobile ? 0 : sidebarOpen ? 30 : 5,
          mt: 0,
          maxWidth: '1400px',
          mx: 'auto',
        }}
      >
        {/* Top Navigation */}
        <TopNav
          onLogout={handleLogout}
          onNotificationClick={handleNotificationClick}
          toggleSidebar={toggleSidebar}
        />

        {/* Main Content */}
        <Box sx={{ p: 3 }}>
          {/* Header */}
          <Paper elevation={2} sx={{ p: 3, mb: 3, background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`, color: 'white' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
              <Box>
                <Typography variant="h4" fontWeight="bold">
                  Hotel Guests Management
                </Typography>
                <Typography variant="subtitle1">
                  Manage and monitor all hotel guests and their activities
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                <Button
                  variant="contained"
                  startIcon={<Download />}
                  onClick={() => {/* Export functionality */}}
                  sx={{ backgroundColor: 'white', color: 'primary.main', '&:hover': { backgroundColor: 'grey.100' } }}
                >
                  Export
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<FilterList />}
                  onClick={() => setFilterDialogOpen(true)}
                  sx={{ borderColor: 'white', color: 'white', '&:hover': { borderColor: 'white', backgroundColor: 'rgba(255,255,255,0.1)' } }}
                >
                  Filters
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<Refresh />}
                  onClick={loadGuests}
                  disabled={loading}
                  sx={{ borderColor: 'white', color: 'white', '&:hover': { borderColor: 'white', backgroundColor: 'rgba(255,255,255,0.1)' } }}
                >
                  Refresh
                </Button>
              </Box>
            </Box>
          </Paper>

          {/* Error Alert */}
          {error && (
            <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError('')}>
              {error}
            </Alert>
          )}

          {/* Statistics Cards */}
          <Grid container spacing={3} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Card elevation={3}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography color="textSecondary" gutterBottom variant="overline">
                        Total Guests
                      </Typography>
                      <Typography variant="h4" color="primary">
                        {stats.totalGuests}
                      </Typography>
                    </Box>
                    <Person sx={{ fontSize: 40, color: 'primary.main' }} />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card elevation={3}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography color="textSecondary" gutterBottom variant="overline">
                        Loyal Guests
                      </Typography>
                      <Typography variant="h4" color="success.main">
                        {stats.loyalGuests}
                      </Typography>
                    </Box>
                    <Loyalty sx={{ fontSize: 40, color: 'success.main' }} />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card elevation={3}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography color="textSecondary" gutterBottom variant="overline">
                        New Guests
                      </Typography>
                      <Typography variant="h4" color="info.main">
                        {stats.newGuests}
                      </Typography>
                    </Box>
                    <Badge color="info" variant="dot" sx={{ '& .MuiBadge-badge': { top: 10, right: 10 } }}>
                      <Person sx={{ fontSize: 40, color: 'info.main' }} />
                    </Badge>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card elevation={3}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography color="textSecondary" gutterBottom variant="overline">
                        Blacklisted
                      </Typography>
                      <Typography variant="h4" color="error.main">
                        {stats.blacklistedGuests}
                      </Typography>
                    </Box>
                    <Block sx={{ fontSize: 40, color: 'error.main' }} />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Search Bar */}
          <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
            <TextField
              fullWidth
              placeholder="Search guests by name, email, phone, or nationality..."
              value={filters.search}
              onChange={handleFilterChange('search')}
              InputProps={{
                startAdornment: <Search sx={{ color: 'text.secondary', mr: 1 }} />,
              }}
            />
          </Paper>

          {/* Active Filters */}
          {(filters.nationality || filters.gender || filters.loyaltyTier || filters.isBlacklisted !== '') && (
            <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
              <Typography variant="subtitle2" gutterBottom>
                Active Filters:
              </Typography>
              <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
                {filters.nationality && (
                  <Chip 
                    label={`Nationality: ${filters.nationality}`} 
                    size="small" 
                    onDelete={() => handleFilterChange('nationality')({ target: { value: '' } })}
                  />
                )}
                {filters.gender && (
                  <Chip 
                    label={`Gender: ${filters.gender}`} 
                    size="small" 
                    onDelete={() => handleFilterChange('gender')({ target: { value: '' } })}
                  />
                )}
                {filters.loyaltyTier && (
                  <Chip 
                    label={`Loyalty: ${filters.loyaltyTier}`} 
                    size="small" 
                    onDelete={() => handleFilterChange('loyaltyTier')({ target: { value: '' } })}
                  />
                )}
                {filters.isBlacklisted !== '' && (
                  <Chip 
                    label={`Blacklisted: ${filters.isBlacklisted === 'true' ? 'Yes' : 'No'}`} 
                    size="small" 
                    onDelete={() => handleFilterChange('isBlacklisted')({ target: { value: '' } })}
                  />
                )}
                <Button size="small" onClick={clearFilters}>
                  Clear All
                </Button>
              </Stack>
            </Paper>
          )}

          {/* Guests Table */}
          <Paper elevation={3}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow sx={{ backgroundColor: theme.palette.primary.main }}>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Guest</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Contact</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Nationality</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Loyalty</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Status</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Last Visit</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredGuests.length > 0 ? (
                        filteredGuests
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((guest) => (
                            <TableRow key={guest.id} hover>
                              <TableCell>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                  <Avatar 
                                    sx={{ 
                                      bgcolor: stringToColor(`${guest.first_name} ${guest.last_name}`),
                                      width: 40, 
                                      height: 40 
                                    }}
                                  >
                                    {guest.first_name?.[0]}{guest.last_name?.[0]}
                                  </Avatar>
                                  <Box>
                                    <Typography variant="body2" fontWeight="medium">
                                      {guest.title} {guest.first_name} {guest.last_name}
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary">
                                      {guest.gender} • {guest.date_of_birth ? formatDate(guest.date_of_birth) : 'N/A'}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <Email fontSize="small" color="action" />
                                    <Typography variant="body2">{guest.email}</Typography>
                                  </Box>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <Phone fontSize="small" color="action" />
                                    <Typography variant="body2">{guest.phone}</Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Chip 
                                  label={guest.nationality || 'Not specified'} 
                                  size="small"
                                  variant="outlined"
                                />
                              </TableCell>
                              <TableCell>
                                <Tooltip title={`${guest.loyalty_points || 0} points`}>
                                  <Chip 
                                    label={getLoyaltyTier(guest.loyalty_points)} 
                                    color={getLoyaltyColor(guest.loyalty_points)}
                                    size="small"
                                  />
                                </Tooltip>
                              </TableCell>
                              <TableCell>
                                {guest.is_blacklisted ? (
                                  <Chip 
                                    label="Blacklisted" 
                                    color="error"
                                    size="small"
                                  />
                                ) : (
                                  <Chip 
                                    label="Active" 
                                    color="success"
                                    size="small"
                                  />
                                )}
                              </TableCell>
                              <TableCell>
                                <Typography variant="body2">
                                  {guest.last_visit_date ? formatDate(guest.last_visit_date) : 'Never'}
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                  {guest.total_stays || 0} stays
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Box sx={{ display: 'flex', gap: 0.5 }}>
                                  <Tooltip title="View Details">
                                    <IconButton 
                                      size="small" 
                                      color="primary"
                                      onClick={() => handleViewDetails(guest)}
                                    >
                                      <Visibility />
                                    </IconButton>
                                  </Tooltip>
                                  {guest.is_blacklisted ? (
                                    <Tooltip title="Remove from Blacklist">
                                      <IconButton 
                                        size="small" 
                                        color="success"
                                        onClick={() => handleToggleBlacklist(guest, false)}
                                      >
                                        <Block />
                                      </IconButton>
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title="Blacklist Guest">
                                      <IconButton 
                                        size="small" 
                                        color="error"
                                        onClick={() => handleToggleBlacklist(guest, true)}
                                      >
                                        <Block />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={7} sx={{ textAlign: 'center', py: 4 }}>
                            <Typography variant="h6" color="textSecondary">
                              No guests found
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                              {Object.values(filters).some(f => f) 
                                ? 'Try adjusting your filters' 
                                : 'No guests have been registered yet'
                              }
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {filteredGuests.length > 0 && (
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={filteredGuests.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(event, newPage) => setPage(newPage)}
                    onRowsPerPageChange={(event) => {
                      setRowsPerPage(parseInt(event.target.value, 10));
                      setPage(0);
                    }}
                  />
                )}
              </>
            )}
          </Paper>

          {/* Filter Dialog */}
          <Dialog 
            open={filterDialogOpen} 
            onClose={() => setFilterDialogOpen(false)}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <FilterList color="primary" />
                <Typography variant="h6">Filter Guests</Typography>
              </Box>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={3} sx={{ mt: 1 }}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>Nationality</InputLabel>
                    <Select
                      value={filters.nationality}
                      onChange={handleFilterChange('nationality')}
                      label="Nationality"
                    >
                      <MenuItem value="">All Nationalities</MenuItem>
                      {nationalities.map((nationality) => (
                        <MenuItem key={nationality} value={nationality}>
                          {nationality}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>Gender</InputLabel>
                    <Select
                      value={filters.gender}
                      onChange={handleFilterChange('gender')}
                      label="Gender"
                    >
                      <MenuItem value="">All Genders</MenuItem>
                      <MenuItem value="Male">Male</MenuItem>
                      <MenuItem value="Female">Female</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>Loyalty Tier</InputLabel>
                    <Select
                      value={filters.loyaltyTier}
                      onChange={handleFilterChange('loyaltyTier')}
                      label="Loyalty Tier"
                    >
                      <MenuItem value="">All Tiers</MenuItem>
                      <MenuItem value="bronze">Bronze (0-99 points)</MenuItem>
                      <MenuItem value="silver">Silver (100-499 points)</MenuItem>
                      <MenuItem value="gold">Gold (500-999 points)</MenuItem>
                      <MenuItem value="platinum">Platinum (1000+ points)</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>Blacklist Status</InputLabel>
                    <Select
                      value={filters.isBlacklisted}
                      onChange={handleFilterChange('isBlacklisted')}
                      label="Blacklist Status"
                    >
                      <MenuItem value="">All Statuses</MenuItem>
                      <MenuItem value="false">Active Only</MenuItem>
                      <MenuItem value="true">Blacklisted Only</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={clearFilters}>Clear All</Button>
              <Button onClick={() => setFilterDialogOpen(false)}>Cancel</Button>
              <Button 
                variant="contained" 
                onClick={() => setFilterDialogOpen(false)}
              >
                Apply Filters
              </Button>
            </DialogActions>
          </Dialog>

          {/* Guest Details Dialog */}
          <Dialog 
            open={detailsDialogOpen} 
            onClose={() => setDetailsDialogOpen(false)}
            maxWidth="lg"
            fullWidth
            scroll="paper"
          >
            <DialogTitle>
              <Typography variant="h6">Guest Details</Typography>
            </DialogTitle>
            <DialogContent dividers>
              {selectedGuest && (
                <Grid container spacing={3}>
                  {/* Guest Information */}
                  <Grid item xs={12} md={6}>
                    <Paper elevation={1} sx={{ p: 3 }}>
                      <Typography variant="h6" gutterBottom color="primary">
                        Personal Information
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                            <Avatar 
                              sx={{ 
                                bgcolor: stringToColor(`${selectedGuest.first_name} ${selectedGuest.last_name}`),
                                width: 60, 
                                height: 60 
                              }}
                            >
                              {selectedGuest.first_name?.[0]}{selectedGuest.last_name?.[0]}
                            </Avatar>
                            <Box>
                              <Typography variant="h5">
                                {selectedGuest.title} {selectedGuest.first_name} {selectedGuest.last_name}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                Guest ID: {selectedGuest.id}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle2" color="textSecondary">Gender</Typography>
                          <Typography variant="body1">{selectedGuest.gender || 'Not specified'}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle2" color="textSecondary">Date of Birth</Typography>
                          <Typography variant="body1">{formatDate(selectedGuest.date_of_birth) || 'Not specified'}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="subtitle2" color="textSecondary">Nationality</Typography>
                          <Typography variant="body1">{selectedGuest.nationality || 'Not specified'}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="subtitle2" color="textSecondary">Address</Typography>
                          <Typography variant="body1">{selectedGuest.address || 'Not specified'}</Typography>
                          <Typography variant="body2" color="textSecondary">
                            {[selectedGuest.city, selectedGuest.state, selectedGuest.country]
                              .filter(Boolean)
                              .join(', ')}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>

                  {/* Contact & Loyalty */}
                  <Grid item xs={12} md={6}>
                    <Paper elevation={1} sx={{ p: 3 }}>
                      <Typography variant="h6" gutterBottom color="primary">
                        Contact & Loyalty
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                            <Email color="action" />
                            <Typography variant="body1">{selectedGuest.email}</Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                            <Phone color="action" />
                            <Typography variant="body1">{selectedGuest.phone}</Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle2" color="textSecondary">Loyalty Points</Typography>
                          <Typography variant="h5" color="primary">
                            {selectedGuest.loyalty_points || 0}
                          </Typography>
                          <Chip 
                            label={getLoyaltyTier(selectedGuest.loyalty_points)} 
                            color={getLoyaltyColor(selectedGuest.loyalty_points)}
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle2" color="textSecondary">Status</Typography>
                          {selectedGuest.is_blacklisted ? (
                            <Box>
                              <Chip label="Blacklisted" color="error" />
                              {selectedGuest.blacklist_reason && (
                                <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                                  Reason: {selectedGuest.blacklist_reason}
                                </Typography>
                              )}
                            </Box>
                          ) : (
                            <Chip label="Active" color="success" />
                          )}
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="subtitle2" color="textSecondary">Emergency Contact</Typography>
                          <Typography variant="body1">
                            {selectedGuest.emergency_contact_name || 'Not specified'}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            {selectedGuest.emergency_contact_phone || ''}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>

                  {/* Booking History */}
                  <Grid item xs={12}>
                    <Paper elevation={1} sx={{ p: 3 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" color="primary">
                          Booking History
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Total Stays: {selectedGuest.total_stays || 0}
                        </Typography>
                      </Box>
                      {historyLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                          <CircularProgress />
                        </Box>
                      ) : guestHistory.length > 0 ? (
                        <TableContainer>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell>Booking #</TableCell>
                                <TableCell>Room</TableCell>
                                <TableCell>Check-in</TableCell>
                                <TableCell>Check-out</TableCell>
                                <TableCell>Amount</TableCell>
                                <TableCell>Status</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {guestHistory.map((booking) => (
                                <TableRow key={booking.id}>
                                  <TableCell>{booking.booking_number}</TableCell>
                                  <TableCell>
                                    {booking.room_name || booking.room_type} 
                                    {booking.room_number && ` (${booking.room_number})`}
                                  </TableCell>
                                  <TableCell>{formatDate(booking.check_in_date)}</TableCell>
                                  <TableCell>{formatDate(booking.check_out_date)}</TableCell>
                                  <TableCell>{formatCurrency(booking.total_amount)}</TableCell>
                                  <TableCell>
                                    <Chip 
                                      label={booking.booking_status} 
                                      color={
                                        booking.booking_status === 'confirmed' ? 'success' :
                                        booking.booking_status === 'checked_in' ? 'info' :
                                        booking.booking_status === 'checked_out' ? 'secondary' :
                                        booking.booking_status === 'cancelled' ? 'error' : 'default'
                                      }
                                      size="small"
                                    />
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      ) : (
                        <Typography variant="body2" color="textSecondary" align="center" sx={{ py: 3 }}>
                          No booking history found for this guest.
                        </Typography>
                      )}
                    </Paper>
                  </Grid>
                </Grid>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setDetailsDialogOpen(false)}>Close</Button>
              {selectedGuest && (
                <Button 
                  variant="contained" 
                  color={selectedGuest.is_blacklisted ? "success" : "error"}
                  onClick={() => handleToggleBlacklist(selectedGuest, !selectedGuest.is_blacklisted)}
                >
                  {selectedGuest.is_blacklisted ? 'Remove from Blacklist' : 'Blacklist Guest'}
                </Button>
              )}
            </DialogActions>
          </Dialog>
        </Box>
      </Box>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default HotelGuestsManagement;